/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Full_Permissions_LabelInputs */



/**
* | output |
* | --- |
* | "Full Permissions" |
*
* @param {Team_Share_Full_Permissions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_full_permissions_label = /** @type {((inputs?: Team_Share_Full_Permissions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Full_Permissions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations complètes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Volle Berechtigungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Permessi completi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Полные права доступа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos completos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("完全权限")
	if (locale === "ja") return /** @type {LocalizedString} */ ("完全な権限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ण अनुमतियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões totais")
	return /** @type {LocalizedString} */ ("Full Permissions")
});